var validEmail = function (email) {
    if (email) {
        return /^[a-z0-9\-._+]+@(?:[a-z0-9\-_]+\.)+[a-z0-9\-_]{2,99}$/i.test(email);
    }
    return true;
};

module.exports = validEmail;
